// Presentation helpers — pure, no PHI. Labels are the thin appointment display labels only
// (no "reason for visit", no condition tags — D5/D10).
const LABELS: Record<string, string> = {
  follow_up: "Follow-up",
  new_visit: "New visit",
  general: "General",
  check_in: "Check-in",
};

export function labelText(label: string): string {
  return LABELS[label] ?? label;
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  });
}

export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  });
}

export function formatDay(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
}

export function age(dobIso?: string | null): string {
  if (!dobIso) return "—";
  const d = new Date(dobIso);
  const diff = Date.now() - d.getTime();
  return String(Math.floor(diff / (365.25 * 24 * 60 * 60 * 1000)));
}

export function isToday(iso: string): boolean {
  const d = new Date(iso);
  const n = new Date();
  return (
    d.getFullYear() === n.getFullYear() &&
    d.getMonth() === n.getMonth() &&
    d.getDate() === n.getDate()
  );
}

export function isThisWeek(iso: string): boolean {
  const t = new Date(iso).getTime();
  const now = Date.now();
  return t >= now && t <= now + 7 * 24 * 60 * 60 * 1000;
}

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export function weekdayLabel(weekday: number): string {
  return WEEKDAYS[weekday] ?? String(weekday);
}
